import { Keys } from '@eih-netbroker/common';
import { useLocale } from '../../../../context/NbLocalizationContext';
import { TwoFactorField } from '../../../../shared/components/two-factor-field/TwoFactorField';
import { useOrderState } from '../OrderStateContext';
import classes from './OrderTwoFactorConfirm.module.scss';

export const OrderTwoFactorConfirm = () => {
  const { translation } = useLocale();
  const { smsCode, setSmsCode, smsCodeError } = useOrderState();

  return (
    <div className={classes.twoFactorConfirm}>
      {smsCodeError?.errorCode === Keys.ErrorCode.twoFactor.orderSmsConfirmationError && (
        <span>{smsCodeError?.errorMessage}</span>
      )}
      {smsCodeError?.errorCode !== Keys.ErrorCode.twoFactor.orderSmsConfirmationError && (
        <TwoFactorField
          label={translation.orderModal.twoFactorConfirm.smsCode}
          onChange={e => setSmsCode(e.target.value)}
          value={smsCode ?? ''}
          errorMessage={smsCodeError?.errorMessage}
          showTooltip
        />
      )}
    </div>
  );
};
